import { all, call, put, take, select, fork } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';

import { notification } from 'antd';

import {
  LOAD_BOOKING_SLOT_LIST,
  HOLD_BOOKING_SLOT,
  RELEASE_BOOKING_SLOT,
  CREATE_BOOKING,
  LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST,
} from '../type';
import {
  loadBookingSlotSuccessAction,
  loadBookingSlotErrorAction,
  holdBookingSlotSuccessAction,
  holdBookingSlotErrorAction,
  releaseBookingSlotSuccessAction,
  releaseBookingSlotErrorAction,
  setHoldBookingSlotAction,
  createBookingErrorAction,
  createBookingSuccessAction,
  loadNextAvailableBookingSlotSuccessAction,
  loadNextAvailableBookingSlotErrorAction,
  // loadBookingSlotListAction,
} from '../action';
import { bookingSlotService } from 'services';
import MessengerResource from 'common/resource/MessengerResource';
import { getBookingTimeSlotData } from 'store/booking/selector';

let bookingTimeSlot;

function* loadBookingSlots() {
  while (1) {
    const action = yield take(LOAD_BOOKING_SLOT_LIST);
    const { callback, socketClient, requestSocket } = action.payload;
    // const requestSocket = action.payload.requestSocket;

    try {
      const response = yield call(
        bookingSlotService.getBookingSlots,
        action.payload,
      );

      callback && callback(response);
      yield put(loadBookingSlotSuccessAction(response));
      const bookingData = yield select(getBookingTimeSlotData);
      bookingTimeSlot = bookingData;
      if (socketClient && requestSocket) {
        yield fork(read, socketClient);
      }
    } catch (error) {
      yield put(loadBookingSlotErrorAction(error));
    }
  }
}

function* loadNextAvailableBookingSlots() {
  while (1) {
    const action = yield take(LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST);
    const { callback, socketClient, requestSocket } = action.payload;
    // const requestSocket = action.payload.requestSocket;

    try {
      const response = yield call(
        bookingSlotService.getNextAvailableBookingSlots,
        action.payload,
      );

      callback && callback(response);
      yield put(loadNextAvailableBookingSlotSuccessAction(response));
      const bookingData = yield select(getBookingTimeSlotData);
      bookingTimeSlot = bookingData;
      if (socketClient && requestSocket) {
        yield fork(read, socketClient);
      }
    } catch (error) {
      yield put(loadNextAvailableBookingSlotErrorAction(error));
    }
  }
}

function processHoldBookingSlot(dataSubscribed, bookingTimeSlot) {
  if (
    dataSubscribed.holdCalendarIDs &&
    Array.isArray(dataSubscribed.holdCalendarIDs)
  ) {
    dataSubscribed.holdCalendarIDs.forEach(holdId => {
      for (let date in bookingTimeSlot) {
        bookingTimeSlot[date].forEach(timeSlot => {
          if (timeSlot.calendarIdList.indexOf(holdId) >= 0) {
            if (!timeSlot.lockID) {
              timeSlot.lockID = {};
            }
            if (!timeSlot.lockID[holdId]) {
              timeSlot.lockID[holdId] = 1;
            } else {
              timeSlot.lockID[holdId] += 1;
            }
            if (timeSlot.lockID[holdId] >= timeSlot.availableBooking) {
              timeSlot.lockSlot = true;
            }
          }
        });
      }
    });
  }
}

function processReleaseBookingSlot(dataSubscribed, bookingTimeSlot) {
  if (dataSubscribed.releaseCalendars) {
    for (let uuid in dataSubscribed.releaseCalendars) {
      for (let date in bookingTimeSlot) {
        for (let i = 0; i < bookingTimeSlot[date].length; i++) {
          let timeSlot = bookingTimeSlot[date][i];
          if (!timeSlot.lockID) {
            continue;
          }
          let max = Number.MIN_SAFE_INTEGER;
          let hasReleased = false;
          for (let i = 0; i < timeSlot.calendarIdList.length; i++) {
            let calendarId = timeSlot.calendarIdList[i];
            if (!timeSlot.lockID[calendarId]) {
              timeSlot.lockID[calendarId] = 0;
              max = Math.max(max, 0);
              continue;
            }
            if (
              dataSubscribed.releaseCalendars[uuid].indexOf(calendarId) >= 0
            ) {
              timeSlot.lockID[calendarId] -= 1;
              hasReleased = true;
            }
            max = Math.max(max, 0);
          }
          if (hasReleased && max < timeSlot.availableBooking) {
            timeSlot.lockSlot = false;
          }
        }
      }
    }
  }
}

function subscribe(socket) {
  return new eventChannel(emit => {
    const socketHandler = (topic, message) => {
      let dataSubscribed = JSON.parse(message.toString());
      console.log('socketData ', dataSubscribed);
      if (!bookingTimeSlot) {
        return;
      }
      processHoldBookingSlot(dataSubscribed, bookingTimeSlot);
      processReleaseBookingSlot(dataSubscribed, bookingTimeSlot);
      emit({
        bookingData: bookingTimeSlot,
      });
    };
    socket.on('message', socketHandler);
    return () => {};
  });
}

function* read(socket) {
  const channel = yield call(subscribe, socket);

  while (true) {
    let responseChannel = yield take(channel);
    yield put(loadBookingSlotSuccessAction({ ...responseChannel.bookingData }));
  }
}

function* holdBookingSlot() {
  while (1) {
    const action = yield take(HOLD_BOOKING_SLOT);
    try {
      const holdBookingSlotResponse = yield call(
        bookingSlotService.holdBookingSlot,
        action.payload.data,
      );
      if (holdBookingSlotResponse && holdBookingSlotResponse.success) {
        if (action.payload.callbackSuccess) {
          action.payload.callbackSuccess(holdBookingSlotResponse);
        }
        yield put(holdBookingSlotSuccessAction());
        yield put(setHoldBookingSlotAction(holdBookingSlotResponse));
      } else {
        notification.error({
          message: MessengerResource.bookingTimeSlot.holdSlotFail,
        });
        yield put(holdBookingSlotErrorAction());
      }
    } catch (err) {
      yield put(holdBookingSlotErrorAction(err));
    }
  }
}

function* releaseBookingSlot() {
  while (1) {
    const action = yield take(RELEASE_BOOKING_SLOT);
    if (action.payload.options && action.payload.options.uuid) {
      try {
        const releaseBookingSlotResponse = yield call(
          bookingSlotService.releaseBookingSlot,
          action.payload.options,
        );
        if (action.payload.callback) {
          action.payload.callback();
        }
        yield put(releaseBookingSlotSuccessAction(releaseBookingSlotResponse));
      } catch (err) {
        yield put(releaseBookingSlotErrorAction(err));
      }
    } else {
      yield put(releaseBookingSlotErrorAction());
    }
  }
}

function* createBooking() {
  while (1) {
    const action = yield take(CREATE_BOOKING);
    const { data, callbackSuccess, callbackError, token } = action.payload;
    try {
      const response = yield call(bookingSlotService.createBooking, {
        data,
        token,
      });
      if (callbackSuccess) {
        callbackSuccess(response);
      }
      yield put(createBookingSuccessAction(response));
    } catch (err) {
      notification.error({
        message: MessengerResource.bookingTimeSlot.holdSlotFail,
        description: err.message,
      });
      callbackError && callbackError();
      yield put(createBookingErrorAction(err));
    }
  }
}

export default function* rootSaga() {
  yield all([
    loadBookingSlots(),
    loadNextAvailableBookingSlots(),
    holdBookingSlot(),
    releaseBookingSlot(),
    createBooking(),
  ]);
}
